module.exports = __webpack_public_path__ + "img/视频封面1.44e377f5.png";